import { useEffect, useState } from 'react'

const useHash = () => {
  const [hash, setHash] = useState<string | undefined>()

  useEffect(() => {
    const onHashChange = () => {
      setHash(/[0-9]+/.exec(window.location.hash)?.[0])
    }
    onHashChange()
    window.addEventListener('hashchange', onHashChange)

    return () => {
      window.removeEventListener('hashchange', onHashChange)
    }
  }, [])

  useEffect(() => {
    if (hash) {
      history.replaceState(null, '', `${location.pathname}#${hash}`)
    }
  }, [hash])

  return [hash, setHash] as [
    string | undefined,
    React.Dispatch<React.SetStateAction<string | undefined>>,
  ]
}

export default useHash
